import React, { useEffect, useRef } from "react";

/**
 * Renders an Elfsight widget by app id. The Elfsight platform.js script
 * (loaded in public/index.html) auto-mounts any `.elfsight-app-<id>` node.
 * On SPA navigation we nudge the platform to re-scan for new widgets.
 */
const ElfsightWidget = ({ appId, className = "", style }) => {
  const ref = useRef(null);

  useEffect(() => {
    const tryInit = () => {
      if (window.eapps && typeof window.eapps.initWidgetsFromBuffer === "function") {
        window.eapps.initWidgetsFromBuffer();
      }
    };
    // platform.js may still be loading — retry a few times
    tryInit();
    const t1 = setTimeout(tryInit, 600);
    const t2 = setTimeout(tryInit, 1600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [appId]);

  return (
    <div
      ref={ref}
      className={`elfsight-app-${appId} ${className}`}
      data-elfsight-app-lazy
      style={style}
    />
  );
};

export default ElfsightWidget;
